import React from 'react';
import { useGame } from '../context/GameContext';
import '../styles/GameOver.css';

const GameOver = ({ type }) => {
  const { restartGame, keepPlaying } = useGame();

  return (
    <div className="game-over">
      <div className="game-over-content">
        <h2>
          {type === 'gameOver' ? 'Game Over!' : 'You Win!'}
        </h2>
        <p>
          {type === 'gameOver'
            ? 'No more moves available.'
            : 'You\'ve reached the 2048 tile!'}
        </p>
        <div className="game-over-actions">
          <button onClick={restartGame}>Try Again</button>
          {type === 'won' && (
            <button onClick={keepPlaying}>Keep Playing</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameOver;